module.exports = __webpack_public_path__ + "static/media/news_slider_phone2.e39026df.png";